// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@bg/XDL/types";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { css } from "styled-components";

const borderSize = "1px";
const disabledAlpha = 0.5;
const size = "20px";
const left = 26;

export default {
    defaultProps: {
        css: css`
            display: flex;
            input {
                opacity: 0;

                + label {
                    margin-left: 5px;
                }

                & + label::before {
                    content: "";
                    position: absolute;
                    left: -${left}px;
                    top: 0;
                    height: ${size};
                    width: ${size};
                    border: 2px solid ${getColor("common.ui4")};
                    border-radius: 100%;
                    background: ${getColor("common.ui4")};
                }

                &:checked:not(:disabled) + label::before {
                    background: ${getColor("common.ui4")};
                    border-color: ${getColor("primary")};
                }

                &:checked:disabled + label::before {
                    border-color: ${getColor("primary")};
                }

                &:checked:disabled + label::after {
                    background: ${getColor("primary")};
                }

                &:checked + label::after,
                &:checked:focus + label::after,
                &:focus:not(:disabled) + label::after {
                    content: "";
                    display: block;
                    height: 10px;
                    width: 10px;
                    border-radius: 100%;
                    background: ${getColor("primary")};
                    position: absolute;
                    left: -21px;
                    top: 5px;
                }
                &:focus,
                &:active {
                    :not(:disabled) + label::before {
                        box-shadow: 0 0 0 2px ${getColor("secondary")};
                    }
                }
                &:disabled + label,
                &:focus:disabled + label {
                    cursor: not-allowed;
                    opacity: 0.5;
                }

                &:hover:not(:disabled) + label {
                    cursor: pointer;
                }

                &:hover:not(:disabled) {
                    box-shadow: none;

                    + label:after {
                        content: "";
                        display: block;
                        height: 10px;
                        width: 10px;
                        border-radius: 100%;
                        position: absolute;
                        left: -21px;
                        top: 5px;
                        background: ${getColor("common.ui4")};
                        border: 2px solid ${getColor("secondary")};
                    }

                    + label::before {
                        border-color: ${getColor("common.ui4")};
                    }

                    &:checked {
                        + label:after {
                            border: 2px solid ${getColor("primary")};
                        }
                    }
                }

                &:checked:input:checked:disabled + label::after {
                    background: ${getColor("primary")};
                }
            }
        `,
    },
    groupDefaultProps: {},
} as xBaseTheme["radio"];
